import { isSystemDark } from './isSystemDark';
import { ThemeMode } from '../schema/ThemeMode';
import {
    THEME_MODE_DARK,
    THEME_MODE_LIGHT,
    THEME_MODE_SYSTEM_DARK,
    THEME_MODE_SYSTEM_LIGHT,
} from '../constants/constants';

export const getThemeModeString = (themeMode: ThemeMode) => {
    switch (themeMode) {
        case ThemeMode.System:
            return isSystemDark() ? THEME_MODE_SYSTEM_DARK : THEME_MODE_SYSTEM_LIGHT;
        case ThemeMode.Light:
            return THEME_MODE_LIGHT;
        case ThemeMode.Dark:
            return THEME_MODE_DARK;
    }
};
